import { computed, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { defineStore } from 'pinia';
import { useLoading } from '@ys/hooks';
import { isArray } from 'lodash-es';
import { SetupStoreId } from '@/enum';
import { useRouterPush } from '@/hooks/common/router';
import { fetachGetImgCode, fetchGetUserInfo, fetchLogin, fetchLoginByCode } from '@/service/api';
import { localStg } from '@/utils/storage';
import { useRouteStore } from '../route';
import { clearAuthStorage, getToken, getUserInfo } from './shared';
// 全局变量tenantId 存储以防登录失败清空存储信息
// let tenantId: number = localStg.get('tenantId');

export const useAuthStore = defineStore(SetupStoreId.Auth, () => {
  const route = useRoute();
  const routeStore = useRouteStore();
  const { toLogin, redirectFromLogin } = useRouterPush(false);
  const { loading: loginLoading, startLoading, endLoading } = useLoading();

  const token = ref(getToken());

  const userInfo: Api.Auth.UserInfo = reactive(getUserInfo());

  /** is super role in static route */
  const isStaticSuper = computed(() => {
    const { VITE_AUTH_ROUTE_MODE, VITE_STATIC_SUPER_ROLE } = import.meta.env;

    return VITE_AUTH_ROUTE_MODE === 'static' && userInfo.roles.includes(VITE_STATIC_SUPER_ROLE);
  });

  /** Is login */
  const isLogin = computed(() => Boolean(token.value));

  /** Reset auth store */
  async function resetStore(loginModule?: any, id?: string, cb?: Function) {
    const authStore = useAuthStore();
    clearAuthStorage();
    authStore.$reset();
    // localStg.set('tenantId',tenantId);
    if (!route.meta.constant) {
      await toLogin(loginModule, undefined, id);
    }
    routeStore.resetStore();
    cb && cb();
  }

  /**
   * Login
   *
   * @param userName User name
   * @param password Password
   * @param [redirect=true] Whether to redirect after login. Default is `true`
   */
  async function login(
    loginInfo: { phone: string; code: string; },
    redirect = true
  ) {
    startLoading();

    const { data: loginToken, error } = await fetchLogin(loginInfo);

    if (!error) {
      const pass = await loginByToken(loginToken);

      if (pass) {
        await routeStore.initAuthRoute();

        if (redirect) {
          await redirectFromLogin();
        }
        if (routeStore.isInitAuthRoute) {
          console.log(userInfo, 'userInfo---------2');
          window.$notification?.destroyAll();
          window.$notification?.success({
            title: '登录成功',
            content: `欢迎回来,${userInfo?.userInfo?.realname}`,
            duration: 4500
          });
        }
      }
    } else {
      const tenantId = localStg.get('tenantId');
      resetStore(undefined, undefined, () => {
        localStg.set('tenantId', tenantId);
      });
    }

    endLoading();
  }
  async function loginByCode(
    loginInfo: { username: string; password: string; captcha: string; checkKey: number },
    redirect = true
  ) {
    startLoading();

    const { data: loginToken, error } = await fetchLoginByCode(loginInfo);

    if (!error) {
      const pass = await loginByToken(loginToken);

      if (pass) {
        await routeStore.initAuthRoute();

        if (redirect) {
          await redirectFromLogin();
        }
        if (routeStore.isInitAuthRoute) {
          console.log(userInfo, 'userInfo---------2');
          window.$notification?.destroyAll();
          window.$notification?.success({
            title: '登录成功',
            content: `欢迎回来,${userInfo?.userInfo?.realname}`,
            duration: 4500
          });
        }
      }
    } else {
      resetStore();
    }

    endLoading();
  }

  function getImgCode(checkKey: number) {
    return new Promise(async (resove, reject) => {
      try {
        const data = await fetachGetImgCode(checkKey);
        resove(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  async function loginByToken(loginToken: Api.Auth.LoginToken) {
    // 1. stored in the localStorage, the later requests need it in headers
    localStg.set('token', loginToken.token);
    localStg.set('refreshToken', loginToken.refreshToken);
    // localStg.set('tenantId', loginToken.userInfo.loginTenantId);

    const { data: info, error } = await fetchGetUserInfo();
    if (!error) {
      //
      const { userInfo: app, sysAllDictItems, sysTentedDetail } = info;
      if (app) {
        if (!app.roles) {
          app.roles = [];
        }
        const { roles = [] } = app;
        if (isArray(roles)) {
          const roleList = roles.map(item => item?.value || item);
          localStg.set('roleList', roleList);
        } else {
          app.roles = [];
          localStg.set('roleList', []);
        }
        localStg.set('userInfo', info);
        localStg.set('sysConfig', sysTentedDetail)
      }
      // 2. store user info
      // localStg.set('userInfo', info);

      // 3. update store
      token.value = loginToken.token;
      Object.assign(userInfo, info);
      console.log(userInfo, 'userInfo---------1');
      return true;
    }
  }

  return {
    token,
    userInfo,
    isStaticSuper,
    isLogin,
    loginLoading,
    resetStore,
    login,
    getImgCode,
    loginByCode
  };
});
